module.exports = __webpack_public_path__ + "professional_dental_placements.png?4a062519f67d0e80e75c3dfa2550ee9e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/dental/professional_dental_placements.png
// module id = 58
// module chunks = 0